<template>
  <div>
    <top-bar/>
    <div class="w3-main" style="margin-top:50px;margin-left: 300px">
      <header class="w3-container" style="padding-top:14px">
          <h6><b>Minhas Faturas</b></h6>
      </header>
      <div class="w3-row-padding" style="margin: 6px 0">
        <div class="w3-col m8 w3-hide-small">&nbsp;</div>
        <div class="w3-col m4">
          <div class="w3-padding-16 w3-round-small w3-center w3-blue-gray" :class="{'w3-red' : saldo < 0}" style="margin-bottom: 15px">
            <div class="w3-large">
              <b>R$ {{saldo | valor}}</b>
            </div>
            <span class="w3-small"><b>Saldo atual</b></span>
          </div>
        </div>
      </div>
      <div class="w3-container">
        <router-link class="w3-button primary w3-block w3-round w3-small w3-padding-16 w3-hide-large" to="/admin/pdv">
          <i class="fa fa-shopping-bag fa-fw w3-xlarge"></i>
          <span><b>COMPRAR</b></span>
        </router-link>
        <div class="w3-white w3-responsive" style="margin: 22px 0">
          <table class="w3-table w3-bordered w3-centered w3-small">
            <tr class="primary">
              <th class="w3-left-align" style="width: 20%">Status</th>
              <th>Mês</th>
              <th>Pago</th>
              <th>Total Comprado</th>
            </tr>
            <tr v-for="c in transacoes" :class="c.status === '0' ? 'status-1' : ''" @click="$router.push('/admin/pdv/' + c.id_transacao)">
              <td class="w3-left-align">{{c.status === "1" ? "Aberto" : c.status === "0" ? "Fechada" : "Aguardando Pagamento"}}</td>
              <td>{{c.mes_transacao | mes}}</td>
              <td>R${{c.total_pago * (-1) | valor}}</td>
              <td>R${{c.total}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TopBar from "../../commons/TopBar.vue"
  import {Money} from 'v-money'

  export default {
    components: {TopBar, Money},

    data() {
      return {
        token: '',
        saldo: 0.00,
        total: 0.00,

        aviso: false,
        adm: false,
        modal: false,
        pagamentos: [],
        pagamento: 0,
        pendente: 0,

        transacoes: [],
        formas_pagamento: [],

        money: {
          decimal: '.',
          thousands: '',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
        },

        totalRecebido: 0,

      }
    },

    methods: {
      buscarTransacoes() {
        openLoading("Buscando Transações");

        let url = base_url + 'transacoes-user/' ;
        let id = this.$route.params.id;
        if (id) {
          url += id + '/';
        }
        this.$http.get(url + this.token)
          .then(response => {
            this.transacoes = response.data.transacoes;
            this.saldo = parseFloat(response.data.total);
            closeLoading();
            //this.buscarPagamentos();

          }, res => {
            console.log(res);
            closeLoading();
            openModalMsg(res.data.result, res.data.msg, true);
        });
      },

      getStatus(status) {
        switch (parseInt(status)) {
          case 1:
            return "Aprovado";

          case 2:
            return "Pendente";

          case 3:
            return "Reprovado";

          default:
            return "elias"
        }
      }
    },

    mounted() {
      this.token = localStorage.getItem('key');
      this.adm = localStorage.getItem('administrativo') && localStorage.getItem('administrativo') === 'true';

      this.buscarTransacoes(false);
    },

    filters: {
      valor(value) {
        if (value !== null && value !== undefined) {
          return parseFloat(value).toFixed(2);
        } else  {
          return parseFloat('0').toFixed(2);
        }
      },

      mes(value) {
        if (value !== null && value !== undefined) {
            switch (parseInt(value)) {
              case 1:
                return "Janeiro";
              case 2:
                return "Fevereiro";
              case 3:
                return "Março";
              case 4:
                return "Abril";
              case 5:
                return "Maio";
              case 6:
                return "Junho";
              case 7:
                return "Julho";
              case 8:
                return "Agosto";
              case 9:
                return "Setembro";
              case 10:
                return "Outubro";
              case 11:
                return "Novembro";
              case 12:
                return "Dezembro";
            }
        }

        return '';

      }
    }
  }
</script>

<style scoped>
  .w3-table tr th {
    text-align: center;
  }
  .w3-table tr td {
    padding: 16px;
    text-align: center;
  }

  .w3-table td {
    vertical-align: middle;
    white-space: nowrap;
    cursor: pointer;
  }

  .status-3 {
    color: #DC143C;
    font-weight: bold;
  }

  .status-1 {
    color: #008B8B;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/comanda/AdminMinhasVendas.vue